import AdminDashboardItem from "../../../types/admin/dashboard/AdminDashboardItem";

export const ADMIN_DASHBOARD_SECTIONS = [
  {
    id: "USERS" as const,
    titleKey: "Pages.Admin.Dashboard.Section.Users",
    defaultTitle: "Users",
    headingId: "admin-dashboard-users-heading",
  },
  {
    id: "JOURNEYS_AND_COMMUNICATIONS" as const,
    titleKey: "Pages.Admin.Dashboard.Section.JourneysAndCommunications",
    defaultTitle: "Journeys & Communications",
    headingId: "admin-dashboard-journeys-communications-heading",
  },
  {
    id: "SYSTEM_CONFIGURATION" as const,
    titleKey: "Pages.Admin.Dashboard.Section.SystemConfiguration",
    defaultTitle: "System Configuration",
    headingId: "admin-dashboard-system-configuration-heading",
  },
  {
    id: "ANALYTICS" as const,
    titleKey: "Pages.Admin.Dashboard.Section.Analytics",
    defaultTitle: "Analytics",
    headingId: "admin-dashboard-analytics-heading",
  },
] as const;

export type AdminDashboardSectionConfig =
  (typeof ADMIN_DASHBOARD_SECTIONS)[number];

export type AdminDashboardDisplayGroup = {
  section: AdminDashboardSectionConfig;
  items: AdminDashboardItem[];
};

const sortItems = (
  items: AdminDashboardItem[],
  getSortLabel: (item: AdminDashboardItem) => string,
): AdminDashboardItem[] =>
  [...items].sort((a, b) =>
    getSortLabel(a).localeCompare(getSortLabel(b)),
  );

export function groupDashboardItemsForDisplay(
  items: AdminDashboardItem[],
  getSortLabel: (item: AdminDashboardItem) => string,
): AdminDashboardDisplayGroup[] {
  return ADMIN_DASHBOARD_SECTIONS.map((section) => ({
    section,
    items: sortItems(
      items.filter((item) => item.section === section.id),
      getSortLabel,
    ),
  })).filter((group) => group.items.length > 0);
}
